import React from "react";

import { styled } from "@mui/material/styles";

import { LocationStatus } from "../../../../../../../util/enums";

interface SytledLocationBadgeProps {
  backgroundColor: string;
  textColor: string;
}

export const SytledLocationBadge = styled("div", {
  shouldForwardProp: (prop) => prop !== "backgroundColor" && prop !== "textColor",
})<SytledLocationBadgeProps>(({ backgroundColor, textColor }) => ({
  display: "inline-block",
  fontFamily: "Manrope",
  fontWeight: 600,
  fontSize: "12px",
  lineHeight: "16px",
  background: `${backgroundColor} !important`,
  color: `${textColor} !important`,
  padding: "8px 12px",
  borderRadius: "100px",
}));

type Props = {
  value?: string;
  backgroundColor?: string;
  dataCy?: string;
  textColor?: string;
  className?: string;
};

const BadgeLocationStatus = (props: Props) => {
  const { value, className, dataCy } = props;

  const renderBadge = (backgroundColor: string, textColor: string, value?: string) => {
    if (value)
      return (
        <SytledLocationBadge
          data-cy={dataCy}
          backgroundColor={backgroundColor}
          textColor={textColor}
          className={className}
        >
          {value}
        </SytledLocationBadge>
      );

    return <> </>;
  };

  switch (value?.toLowerCase()) {
    case LocationStatus.IN_USE.toLowerCase():
      return renderBadge("#F4F3FF", "#6938EF", value);
    case LocationStatus.EMPTY.toLowerCase():
      return renderBadge("#F2F4F7", "#475467", value);
    default:
      return renderBadge("#F2F4F7", "#475467", value);
  }
};

export default BadgeLocationStatus;
